import { Button, PageHeader } from 'components';
import { Form, Upload, Select, Table, Input } from 'antd';
import styles from './style.module.scss';
import { ImportOutlined, InboxOutlined } from '@ant-design/icons';
import { Card } from 'antd';
import { useTranslation } from 'react-i18next';
import FormHelper from 'helpers/FormHelper';
import useCalendars from '../useCalendars';

const { Option } = Select;

const Import = () => {
  const { t } = useTranslation();
  const { shoppingCenters, handleImportExcel, form } = useCalendars(false);
  const onFinish = async (values) => {
    await handleImportExcel(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const handleCreate = () => {
    form.submit();
  };

  return (
    <div>
      <PageHeader title={t('IMPORTA Footfall & Calendar')}>
        <Button
          width={'150px'}
          onClick={handleCreate}
          big
          icon={<ImportOutlined />}
        >
          {t('IMPORT')}
        </Button>
      </PageHeader>
      <div className={styles.content}>
        <Card>
          <Form
            form={form}
            name='basic'
            wrapperCol={{ span: 24 }}
            initialValues={{
              shopping_center_id: '',
            }}
            onFinishFailed={onFinishFailed}
            onFinish={onFinish}
            autoComplete='off'
          >
            <Form.Item
              label={t('Outlet Village')}
              name={'shopping_center_id'}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 8 }}
              labelAlign={'left'}
            >
              <Select
                placeholder={t('Outlet Village')}
                style={{ width: '100%' }}
              >
                {shoppingCenters.map((i) => (
                  <Option key={i.id} value={i.id}>
                    {i.title}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label={t('Note')}
              name={'comment'}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 8 }}
              labelAlign={'left'}
            >
              <Input.TextArea />
            </Form.Item>
            <Form.Item
              label='Dragger'
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 12 }}
              labelAlign={'left'}
            >
              <Form.Item
                name='file'
                valuePropName='fileList'
                getValueFromEvent={FormHelper.normFile}
                noStyle
                multiple={false}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Upload.Dragger
                  multiple={false}
                  name='file'
                  beforeUpload={FormHelper.beforeUpload}
                >
                  <p className='ant-upload-drag-icon'>
                    <InboxOutlined />
                  </p>
                  <p className='ant-upload-text'>
                    {t('Click or drag file to this area to upload')}
                  </p>
                  <p className='ant-upload-hint'>
                    {t('Support for a single or bulk upload.')}
                  </p>
                </Upload.Dragger>
              </Form.Item>
            </Form.Item>
            <Form.Item
              label={t('Esempio')}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
              labelAlign={'left'}
            >
              <Table
                pagination={false}
                columns={[
                  {
                    title: t('Data'),
                    dataIndex: 'date',
                  },
                  {
                    title: t('Aperture'),
                    dataIndex: 'aperture',
                  },
                  {
                    title: t('Tipo Giorno'),
                    dataIndex: 'type',
                  },
                  {
                    title: t('Trading calendar'),
                    dataIndex: 'trading_calendar',
                  },
                  {
                    title: t('Note'),
                    dataIndex: 'note',
                  },
                ]}
                dataSource={[
                  {
                    date: '2023-12-23',
                    aperture: 'Apertura',
                    type: 'Feriale',
                    trading_calendar: 'Saldi Natale 2023',
                    note: 'Note',
                  },
                  {
                    date: '2023-12-24',
                    aperture: 'Chiusura Straordinaria',
                    type: 'Festivo',
                    trading_calendar: 'Saldi Natale 2023',
                    note: 'Note',
                  },
                  {
                    date: '2023-12-25',
                    aperture: 'Chiusura Ordinara',
                    type: 'Chiusura',
                    trading_calendar: 'Saldi Natale 2023',
                    note: 'Note',
                  },
                ]}
              />
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default Import;
